import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1 } from "../SlotGameType1";
import { MarkersInfoColors } from "../WinLineInfoMarkers";


// namespace SlotGames {

export class BurningFruits extends SlotGameType1 {
	protected override panelFactory: IPanelFactory = new BurningFruitsPanelFactory();
	protected override helpFactory: IHelpFactory = new BurningFruitsHelpFactory();

	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "white",
			coloroutherStroke: "black",
			colorinnerStroke: "darkred",
		}

	//LED COLOR
	protected override ColorLed: string = "250,0,0\n";



	constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "BurningFruits") {
		super(multigameParams, initData, gameName);
		this.spinnableReelsParams.topBorderWidth = 21;
		this.spinnableReelsParams.bottomBorderWidth = 13;
	}
	protected override colorLineMarkers: MarkersInfoColors =
	{
		MarkerbackgroundColor: "linear-gradient(90deg, rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	};
}

//Panel Colorized
class BurningFruitsPanelFactory implements IPanelFactory {
	public CreateNewPanel(params: PanelParams): Panel {
		return new BurningFruitsPanel(params);
	}
}

class BurningFruitsPanel extends Panel {
	protected override ButtonBackground(): ButtonColors {
		let color: ButtonColors = {
			backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
		};
		return color;

	}

}

class BurningFruitsHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new BurningFruitsHelp(params);
	}
}

class BurningFruitsHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(15,19,89),rgb(45,51,166), rgb(90,97,242),rgb(45,51,166),rgb(15,19,89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}